import { render, staticRenderFns } from "./TaxId.vue?vue&type=template&id=5decb493"
import script from "./TaxId.vue?vue&type=script&lang=js"
export * from "./TaxId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports